export const STORE_MENU_CATALOG = [
  { id: "home", label: "Home", group: "Overview", paths: ["/home"], exact: true },
  { id: "dashboard", label: "Loyalty Report", group: "Overview", paths: ["/dashboard"] },
  { id: "dashboardPlus", label: "Cashi Plus", group: "Overview", paths: ["/dashboardPlus"], exact: true },
  { id: "couponlist", label: "Coupons & Rewards", group: "Offers", paths: ["/couponlist"] },
  { id: "createcoupon", label: "Create Coupon", group: "Offers", paths: ["/createcoupon"] },
  { id: "spinwin", label: "Spin To Win", group: "Offers", paths: ["/spinwin", "/dashboardPlus/spinwin"] },
  { id: "luckydraws", label: "Lucky Draw Coupons", group: "Offers", paths: ["/luckydraws", "/luckydraw"] },
  { id: "luckydrawcoupon", label: "Print Coupons", group: "Offers", paths: ["/luckydrawcoupon", "/luckydrawcouponback", "/luckydrawcouponQr", "/luckydrawredeem"] },
  { id: "printphysicalcard", label: "Print Loyalty Cards", group: "Offers", paths: ["/printphysicalcard", "/printphysicalback", "/printphysicalqr"] },
  { id: "reviewList", label: "Customer Reviews", group: "Offers", paths: ["/reviewList"] },
  { id: "customerList", label: "Customers", group: "Activity", paths: ["/customerList"] },
  { id: "issuedList", label: "Issued coupons", group: "Activity", paths: ["/issuedList"] },
  { id: "redeemedList", label: "Redeemed coupons", group: "Activity", paths: ["/redeemedList"] },
  { id: "saleReport", label: "Sales", group: "Activity", paths: ["/saleReport"] },
  { id: "registerSale", label: "Register sale", group: "Activity", paths: ["/registerSale"] },
  { id: "customerReport", label: "Customer report", group: "Activity", paths: ["/customerReport"] },
  { id: "physicalCard", label: "Issued cards", group: "Activity", paths: ["/physicalCard"] },
  { id: "wallet", label: "Wallet", group: "Activity", paths: ["/wallet"] },
  { id: "audit", label: "Audit trail", group: "Activity", paths: ["/audit"] },
  { id: "loyaltysetting", label: "Loyalty Settings", group: "Activity", paths: ["/loyaltysetting"] },
  { id: "loadQR", label: "QR list", group: "QR coupons", paths: ["/dashboardPlus/loadQR"] },
  { id: "generatedQR", label: "Generated QR", group: "QR coupons", paths: ["/dashboardPlus/generatedQR"] },
  { id: "loadedQR", label: "Loaded QR", group: "QR coupons", paths: ["/dashboardPlus/loadedQR"] },
  { id: "activatedQR", label: "Activated QR", group: "QR coupons", paths: ["/dashboardPlus/activatedQR"] },
  { id: "loadnactiveqr", label: "Load and activate", group: "QR coupons", paths: ["/dashboardPlus/loadnactiveqr"] },
  { id: "plusRedeemed", label: "QR redeems", group: "QR coupons", paths: ["/dashboardPlus/redeemed"] },
  { id: "plusCustomers", label: "Plus customers", group: "QR coupons", paths: ["/dashboardPlus/totalPlusCustomer"] },
  { id: "walletPlus", label: "Plus wallet", group: "QR coupons", paths: ["/dashboardPlus/walletPlus"] },
  { id: "users", label: "Users", group: "Users", paths: ["/users", "/dashboardPlus/users"] },
];

export const CLUB_MENU_CATALOG = [
  { id: "home", label: "Dashboard", group: "Club", paths: ["/club/home"], exact: true },
  { id: "stores", label: "Stores", group: "Club", paths: ["/club/stores"] },
  { id: "luckydraw", label: "Lucky Draw Coupons", group: "Club", paths: ["/club/luckydraw", "/club/luckydraw-winner"] },
  { id: "print", label: "Print Loyalty Cards", group: "Club", paths: ["/club/print"] },
  { id: "loyalty", label: "Loyalty Settings", group: "Club", paths: ["/club/loyalty"] },
  { id: "loyaltyhistory", label: "Loyalty history", group: "Club", paths: ["/club/loyalty-history"] },
  { id: "wallet", label: "Wallet", group: "Club", paths: ["/club/wallet"] },
  { id: "audit", label: "Audit trail", group: "Club", paths: ["/club/audit"] },
  { id: "users", label: "Users", group: "Users", paths: ["/club/users"] },
];

export function staffOf(session) {
  return session?.staff_info || null;
}

export function isOwner(session) {
  const staff = staffOf(session);
  return !staff || staff.is_owner === true;
}

export function hasMenu(session, menu) {
  if (isOwner(session)) return true;
  return (staffOf(session)?.menus || []).includes(menu);
}

export function canAdd(session) {
  if (isOwner(session)) return true;
  return staffOf(session)?.can_add === "1";
}

export function canEdit(session) {
  if (isOwner(session)) return true;
  return staffOf(session)?.can_edit === "1";
}

export function filterGroups(groups, session) {
  if (isOwner(session)) return groups;
  const menus = new Set(staffOf(session)?.menus || []);
  return groups
    .map((group) => ({ ...group, items: (group.items || []).filter((item) => menus.has(item.menu)) }))
    .filter((group) => group.items.length);
}

function matchesPath(pathname, entry) {
  return (entry.paths || []).some((path) => {
    if (entry.exact) return pathname === path;
    return pathname === path || pathname.startsWith(`${path}/`);
  });
}

export function pathAllowed(pathname, session, catalog) {
  if (isOwner(session)) return true;
  const menus = staffOf(session)?.menus || [];
  return catalog.some((entry) => menus.includes(entry.id) && matchesPath(pathname, entry));
}

export function firstAllowedPath(session, groups, fallback) {
  const items = filterGroups(groups, session).flatMap((group) => group.items);
  return items[0]?.to || fallback;
}
